import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const CompareModal = ({ CompareData, ...props }) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="compare-plan-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="header">
          <h3>
            Do you want to choose the{" "}
            <span>
              {CompareData?.switching_plan_data?.plan_name
                ? CompareData?.switching_plan_data?.plan_name
                : ""}{" "}
              Plan
            </span>
          </h3>
          <p>(You will be charged as per the plan you select)</p>
        </div>
        <p>To change your plan, please reduce usage per plan limits.</p>
        <br />
        <p>
          You can do this by going to your accounts page and removing the
          vouchers and coupons that are exceeding the limit.
        </p>
        <br />
        <p>
          Please go to My Profile - Marketplace Membership tab and unsubscribe
          to the marketplaces exceeding the limit.{" "}
        </p>
        <div className="compare-table">
          <table>
            <thead>
              <tr>
                <th>Deals</th>
                <th>
                  {CompareData?.switching_plan_data?.plan_name
                    ? CompareData?.switching_plan_data?.plan_name
                    : ""}{" "}
                  Plan
                </th>
                <th>
                  Current Plan (
                  {CompareData?.current_plan_data?.plan_name
                    ? CompareData?.current_plan_data?.plan_name
                    : ""}
                  )
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Marketplaces</td>
                <td>
                  {CompareData?.switching_plan_data?.marketplace_count
                    ? CompareData?.switching_plan_data?.marketplace_count
                    : 0}
                </td>
                <td>
                  {CompareData?.current_plan_data?.marketplace_count
                    ? CompareData?.current_plan_data?.marketplace_count
                    : 0}
                </td>
              </tr>
              <tr>
                <td>Vouchers</td>
                <td>
                  {CompareData?.switching_plan_data?.voucher_count
                    ? CompareData?.switching_plan_data?.voucher_count
                    : 0}
                </td>
                <td>
                  {CompareData?.current_plan_data?.voucher_count
                    ? CompareData?.current_plan_data?.voucher_count
                    : 0}
                </td>
              </tr>
              <tr>
                <td>Coupons</td>
                <td>
                  {CompareData?.switching_plan_data?.coupon_count
                    ? CompareData?.switching_plan_data?.coupon_count
                    : 0}
                </td>
                <td>
                  {" "}
                  {CompareData?.current_plan_data?.coupon_count
                    ? CompareData?.current_plan_data?.coupon_count
                    : 0}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CompareModal;
